import Vue from 'vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import GoodTableSearch from '@core/components/good-table-search/GoodTableSearch.vue'
import CustomMultipleSelectFilter from '@core/components/custom-select-filter/CustomMultipleSelectFilter.vue'

Vue.component(FeatherIcon.name, FeatherIcon)
Vue.component('GoodTableSearch', GoodTableSearch)
Vue.component('CustomMultipleSelectFilter', CustomMultipleSelectFilter)
